export interface IPackageTargetingCriterionValueApi {
  packagecriterionvalue_id?: number;
  packagetargetingcriterion_id?: number;
  code: string;
  value: string;
}

export interface IPackageTargetingCriterionApi {
  package_id: number;
  packagetargetingcriterion_id: number;
  packagetargetingcriterion_values: IPackageTargetingCriterionValueApi[];
  targetingcriterion_id: number;
}

export default class PackageTargetingCriterion {
  packageID: number;
  targetingCriterionID: number;
  values: IPackageTargetingCriterionValueApi[];
  id: number;

  constructor(
    id: number = -1,
    packageID: number = -1,
    targetingCriterionID: number = -1,
    values: IPackageTargetingCriterionValueApi[] = [],
  ) {
    this.id = id;
    this.packageID = packageID;
    this.targetingCriterionID = targetingCriterionID;
    this.values = values;
  }

  static fromApi(apiObject: IPackageTargetingCriterionApi): PackageTargetingCriterion {
    return new PackageTargetingCriterion(
      apiObject.packagetargetingcriterion_id,
      apiObject.package_id,
      apiObject.targetingcriterion_id,
      apiObject.packagetargetingcriterion_values,
    );
  }

  toApi(): IPackageTargetingCriterionApi {
    return {
      package_id: this.packageID,
      packagetargetingcriterion_id: this.id,
      packagetargetingcriterion_values: this.values,
      targetingcriterion_id: this.targetingCriterionID,
    };
  }
}
